import axios from './network.js'

let productAPI = {
  // 通过经纬度获取国内外接口
  getAddress: function (data, success, failure) {
    return axios.postJson("/Home/Common/getAddress", data, success, failure);
  },
  // 语言接口
  getLanguageList: function (data, success, failure) {
    return axios.postJson("/Home/Language/getList", data, success, failure);
  },
  // 汇率列表
  getRateList: function (data, success, failure) {
    return axios.postJson("/Home/ExchangeRate/getList", data, success, failure);
  },
  // 商品分类列表
  getCategoryList: function (data, success, failure) {
    return axios.postJson("/Home/Product/getCategoryList", data, success, failure);
  },
  // 商品标记列表
  getProductSignList: function (data, success, failure) {
    return axios.postJson("/Home/Product/getProductSignList", data, success, failure);
  },
  // 我们的产品列表
  getProductList: function (data, success, failure) {
    return axios.postJson("/Home/Product/getProductList", data, success, failure);
  },
  // 用户领取优惠券
  addUserCoupon: function (data, success, failure) {
    return axios.postJson("/Home/Coupon/addUserCoupon", data, success, failure);
  },
  // 优惠券列表
  getCouponList: function (data, success, failure) {
    return axios.postJson("/Home/Coupon/getList", data, success, failure);
  },
  // 优惠券列表下的商品列表
  getProductListByCoupon: function (data, success, failure) {
    return axios.postJson("/Home/Coupon/getProductList", data, success, failure);
  },
  // 限时活动商品列表
  getProductListByDiscount: function (data, success, failure) {
    return axios.postJson("/Home/TimeDiscount/getProductList", data, success, failure);
  },
  // 加入购物车
  addCart: function (data, success, failure) {
    return axios.postJson("/Home/Cart/addCart", data, success, failure);
  },
  // 组合活动下的商品
  getAllListBycombination: function (data, success, failure) {
    return axios.postJson("/Home/PortfolioSales/getAllList", data, success, failure);
  },
  // 产品详情页
  getProductDetail: function (data, success, failure) {
    return axios.postJson("/Home/Product/getDetail", data, success, failure);
  },
  // 获取商品价格
  getDetailPriceBySku: function (data, success, failure) {
    return axios.postJson("/Home/Product/getDetailPrice", data, success, failure);
  },
  // 商品评价列表
  getCommentList: function (data, success, failure) {
    return axios.postJson("/Home/Comment/getList", data, success, failure);
  },
  // 购物车列表
  getCartList: function (data, success, failure) {
    return axios.postJson("/Home/Cart/getList", data, success, failure);
  },
  // 购物车添加修改数量
  setCartNum: function (data, success, failure) {
    return axios.postJson("/Home/Cart/updNum", data, success, failure);
  },
  // 订单,购物车选中数据是否满足满减
  getDataDiscount: function (data, success, failure) {
    return axios.postJson("/Home/Discount/getData", data, success, failure);
  },
  // 获取支付方式列表
  getPaymentList: function (data, success, failure) {
    return axios.postJson("/Home/Pay/getPaymentList", data, success, failure);
  },
  // 获取运费方式列表
  getPaymentList: function (data, success, failure) {
    return axios.postJson("/Home/Freight/getFreightList", data, success, failure);
  },
  // 获取订单中优惠券列表
  getUserOrderCoupon: function (data, success, failure) {
    return axios.postJson("/Home/Order/getUserOrderCoupon", data, success, failure);
  },
  // 我的订单
  getUserOrderList: function (data, success, failure) {
    return axios.postJson("/Home/Order/getUserOrder", data, success, failure);
  },
  // 我的订单
  getUserOrderCount: function (data, success, failure) {
    return axios.postJson("/Home/Order/getUserOrderCount", data, success, failure);
  },
  // 订单-取消订单-确认收货
  dealOrder: function (data, success, failure) {
    return axios.postJson("/Home/Order/dealOrder", data, success, failure);
  },
  // 订单-删除
  deleteUserOrder: function (data, success, failure) {
    return axios.postJson("/Home/Order/deleteUserOrder", data, success, failure);
  },
  // 获取订单详情
  getUserOrderDetail: function (data, success, failure) {
    return axios.postJson("/Home/Order/getUserOrderDetail", data, success, failure);
  },
  // 下单
  productOrder: function (data, success, failure) {
    return axios.postJson("/Home/Order/order", data, success, failure);
  },
  // 下单
  productOrders: function (data, success, failure) {
    return axios.postJson("/Home/Order/orders", data, success, failure);
  },
  // 
  // 获取支付方式列表
  getPaymentList: function (data, success, failure) {
    return axios.postJson("/Home/Pay/getPaymentList", data, success, failure);
  },
  // 获取运费方式列表
  getFreightList: function (data, success, failure) {
    return axios.postJson("/Home/Freight/getFreightList", data, success, failure);
  },
  // 切换国家，运输方式 订单获取运费税费
  getExtraPrice: function (data, success, failure) {
    return axios.postJson("/Home/Order/getExtraPrice", data, success, failure);
  },
  // 切换国家，运输方式 订单获取运费税费
  getExtraPrices: function (data, success, failure) {
    return axios.postJson("/Home/Order/getExtraPrices", data, success, failure);
  },
  // 获取订单页面产品
  getProductByOrder: function (data, success, failure) {
    return axios.postJson("/Home/Order/getProduct", data, success, failure);
  },
  // 获取订单页面产品
  getOrderProductList: function (data, success, failure) {
    return axios.postJson("/Home/Order/getOrderProductList", data, success, failure);
  },
  // 获取订单详情
  getUserOrderDetail: function (data, success, failure) {
    return axios.postJson("/Home/Order/getUserOrderDetail", data, success, failure);
  },
  // 支付
  orderPay: function (data, success, failure) {
    return axios.postJson("/Home/Pay/orderPay", data, success, failure);
  },
  // 支付测试
  testPay: function (data, success, failure) {
    return axios.postJson("/Home/Pay/testPay", data, success, failure);
  },
  // 加入收藏
  addCollect: function (data, success, failure) {
    return axios.postJson("/Home/Product/addCollect", data, success, failure);
  },
  // 取消收藏
  cancelCollect: function (data, success, failure) {
    return axios.postJson("/Home/Product/cancelCollect ", data, success, failure);
  },
  // 我的收藏
  userProductCollect: function (data, success, failure) {
    return axios.postJson("/Home/Product/userProductCollect ", data, success, failure);
  },
  // 我的评价
  userProductComment: function (data, success, failure) {
    return axios.postJson("/Home/Product/userProductComment ", data, success, failure);
  },
  // 我的评价-博客
  myCommentBlog: function (data, success, failure) {
    return axios.postJson("/Home/User/myCommentBlog ", data, success, failure);
  },
  // 查询支付结果
  successPay: function (data, success, failure) {
    return axios.postJson("/Home/Pay/successPay ", data, success, failure);
  },
  // 取消支付查询
  cancelPay: function (data, success, failure) {
    return axios.postJson("/Home/Pay/cancelPay ", data, success, failure);
  },
  // 清空购物车
  deleteAllCart: function (data, success, failure) {
    return axios.postJson("/Home/Cart/deleteAllCart ", data, success, failure);
  },
  // 商品询价。疑问
  submitProductConsult: function (data, success, failure) {
    return axios.postJson("/Home/Product/submitProductConsult ", data, success, failure);
  },
  // 订单评价
  appraises: function (data, success, failure) {
    return axios.postJson("/Home/Order/appraises", data, success, failure);
  },
}

export default productAPI



// WEBPACK FOOTER //
// ./src/api/productAPI.js